<template>
  <div class="row v-grid1 p2p-video-main" data-grm-comp="RoomCallP2P" ref="main" style="width: 100%; height: 100%;">
    <div class="video-vip"
      v-if="!pip"
    >
      <RoomCallP2PVideo class="main-video"
          v-if="mainVideoUser.userId"
          :user="mainVideoUser"
      />
    </div>

    <div class="sub-videos"
      v-if="subVideoUserList && subVideoUserList.length > 0 && (pip || isRoomMode('call'))"
      ref="subVideos"
      :data-pip-mode="pip"
    >
      <RoomCallP2PVideo class="sub-video"
        v-for="(user, idx) in subVideoUserList"
        :key="user.userId + '@' + user.screenShare"
        :user="user"
        :idx="idx"
        :defaultVideoObjectFit="'cover'"
        @click="setMainVideo"
        @mounted="addSubVideosObserve"
        @destroyed="removeSubVideosObserve"
      />
    </div>
  </div>
</template>

<script>
import RoomCallP2PVideo from "@/components/Room/Call/p2p/RoomCallP2PVideo";
import {mapGetters} from "vuex";
export default {
  name: "RoomCallP2P",
  components: {RoomCallP2PVideo},

  props: {
    pip: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      mainVideoUser: {
        userId: null,
        screenShare: false
      },
      subVideoUserList: []
    }
  },

  created: function(){
    console.log('call p2p main create : length[%d]',
        this.roomUserList.length);

    // window._c = this;

    this.$roomApi.addEventListeners((this._Events = _Events()), this);

    // set roomUserList
    (() => {
      // 필요한 정보객체 생성
      let userList = this.roomUserList.map(roomUser => {
        return {userId: roomUser.userId, screenShare: false, roomUser};
      });

      // 정렬 : 내가 아닌 사용자가 맨 처음
      userList.sort((a,b) => {
        if(this.isMe(a.userId)){
          return 1;
        }
        if(a.screenStatus){
          return -1;
        }else if(b.screenShare){
          return 1;
        }
        return -1;
      });

      // add sub video
      this.addSubVideoUserList(userList);

      // pip 면 완료
      if(this.pip){
        return;
      }

      // screenShare mode
      if(this.isRoomMode('screenShare')){
        const user = userList.find(user => user.roomUser.screenStatus);
        if(user){
          this.setMainVideo({
            userId: user.userId,
            screenShare: true
          });
          return;
        }
      }

      if(userList.length === 1){
        this.setMainVideo(userList[0]);
        return;
      }

      let user = userList.find(user => !this.isMe(user.userId));
      if(!user){
        user = this.subVideoUserList[0];
      }
      this.setMainVideo(user);
    })();
  },
  mounted() {
  },
  destroyed() {
    this.$roomApi.removeEventListeners(this._Events);
    this.subVideoObserver?.disconnect();
  },

  computed: {
    ...mapGetters('room', ['isRoomMode']),
    ...mapGetters('user', [
      'me',
      'isMe',
      'getRoomUser',
      'roomUserList',
      'roomUserCount'
    ]),
  },

  methods: {
    setMainVideo: function(roomUser){
      if(this.pip){
        return;
      }

      const currentUser = Object.assign({}, this.mainVideoUser);
      const {userId, screenShare} = roomUser;
      if(
        currentUser.userId === userId
        && currentUser.screenShare === screenShare
      ){
        return;
      }

      const idx = this.subVideoUserList.findIndex(user => {
        return user.userId === userId && user.screenShare === screenShare;
      });
      if(idx > -1){
        this.subVideoUserList.splice(idx, 1);
      }

      if(currentUser.userId){
        Object.assign(this.mainVideoUser, {userId: null, screenShare: null});
        this.addSubVideoUserList(currentUser);
      }
      Object.assign(this.mainVideoUser, {userId, screenShare, _createdAt: Date.now()});
      // console.log('@@@@ set main video :', this.mainVideoUser);
    },
    addSubVideoUserList: function(roomUser){
      if(Array.isArray(roomUser)){
        roomUser.forEach(ru => {
          this.addSubVideoUserList(ru);
        })
        return;
      }

      if(
        this.mainVideoUser
        && this.mainVideoUser.userId === roomUser.userId
        && !!this.mainVideoUser.screenShare === !!roomUser.screenShare
      ){
        return;
      }

      if(this.subVideoUserList.some(user => {
        return user.userId === roomUser.userId
          && !!user.screenShare === !!roomUser.screenShare;
      })){
        return;
      }
      this.subVideoUserList.push({
        userId: roomUser.userId,
        screenShare: !!roomUser.screenShare,
        _createdAt: Date.now()
      });
    },
    removeVideo: function({userId, screenShare, all=false}){
      let idx = -1;
      while((idx=this.subVideoUserList.findIndex(ru => {
        if(!all && ru.screenShare !== screenShare){
          return false;
        }
        return ru.userId === userId;
      })) > -1){
        this.subVideoUserList.splice(idx, 1);
      }

      let isMainUser = (this.mainVideoUser.userId === userId
          && (all || !!this.mainVideoUser.screenShare === !!screenShare));
      if(isMainUser){
        Object.assign(this.mainVideoUser, {
          userId: null, screenShare: false
        })

        const user = this.subVideoUserList.shift();
        this.setMainVideo(user);
      }
    },
    addSubVideosObserve: function($roomCallVideo){
      if(!$roomCallVideo.$el){
        console.warn('$roomCallVideo.$el is null', $roomCallVideo);
        return;
      }

      if(!this.$refs.subVideos){
        console.warn('subVideos is null');
        return;
      }

      if(this.subVideoObserver?.isConnected){
        if(this.subVideoObserver.root && !this.subVideoObserver.root.isConnected){
          this.subVideoObserver.disconnect();
          this.subVideoObserver = null;
        }
      }

      if(!this.subVideoObserver){
        this.subVideoObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            // console.log('@@@ GrmDomIntersect : intersect[%s], ratio[%d]',
            //     entry.isIntersecting, entry.intersectionRatio, entry.target.__vue__.roomUser.nickname,
            //     entry.target, entry);
            entry.target.setAttribute('intersecting', entry.isIntersecting);
            const event = new Event('GrmDomIntersect');
            event.isIntersecting = entry.isIntersecting;
            event.intersectionRatio = entry.intersectionRatio;
            entry.target?.__vue__?.onRoomVideoResize(event, {immediate: this.pip && entry.isIntersecting});
          })
        }, {
          // root: this.$refs.subVideos,
          rootMargin: '0px',
          threshold: 0.3
        });
      }

      this.subVideoObserver.observe($roomCallVideo.$el);
    },
    removeSubVideosObserve: function($roomCallVideo){
      if(!this.subVideoObserver) return;
      if(!$roomCallVideo?.$el) return;
      this.subVideoObserver.unobserve($roomCallVideo?.$el);
    },
    setSubVideoVAD: function({userId, volume, avgVolumeSecond}){
      const VOLUME_LIMIT = 2;

      if(avgVolumeSecond !== undefined ){
        // 일정볼륨 보다 커야함
        if(avgVolumeSecond < VOLUME_LIMIT){
          return;
        }

        const list = this.subVideoUserList;

        // 현재 화자이면 return
        if(list[0].userId === userId || list.length <= 1){
          return;
        }

        // 첫번째 위치로 변경
        const idx = list.findIndex(user => user.userId===userId);
        if(idx > 0){
          // swap
          list.unshift(list.splice(idx, 1)[0])
        }
        return;
      }

      // 일정볼륨 보다 커야함
      if(volume < VOLUME_LIMIT){
        return;
      }

      const list = this.subVideoUserList;

      // 현재 화자이면 return
      if(list[0].userId === userId || list.length <= 1){
        return;
      }

      const vad = this._tmp_user_vad = this._tmp_user_vad || {};

      // 마지막 발언자가 아니면 새로 기록
      if(vad.userId !== userId){
        vad.userId = userId;
        vad.lastTime = Date.now();
        return;
      }

      // 1초 이하 발언 return
      if(Date.now()-(vad.lastTime || 0) < 500){
        return;
      }

      // 첫번째 위치로 변경
      const idx = list.findIndex(user => user.userId===userId);
      if(idx > 0){
        // swap
        list.unshift(list.splice(idx, 1)[0])
      }

    }
  }
}

function _Events(){
  return {
    room_user_enter: function(e) {
      const roomUser = this.getRoomUser({userId: e.data.roomUser.userId});
      this.addSubVideoUserList(roomUser);

      if(!this.mainVideoUser.screenShare){
        // main 이 없거나 혼자 있을 때
        if(!this.mainVideoUser?.userId || this.mainVideoUser.userId === this.me.userId){
          this.setMainVideo(roomUser);
        }
      }
    },
    room_user_leave: function(e) {
      const { userId } = e.data;
      this.removeVideo({userId, all:true});
    },
    room_call_screenShare: function(e) {
      const start = e.data.screenShare;
      console.log('screen %s :', start ? 'start' : 'stop', e)

      if(start){
        this.setMainVideo({
          userId: e.data.userId,
          screenShare: true
        });
      }else{
        this.removeVideo({
          userId: e.data.targetUserId,
          screenShare: true
        })
      }
    },
    room_call_loadScreenShareStream: function(e) {
      this.setMainVideo({
        userId: this.me.userId,
        screenShare: true
      });
    },
    room_call_userMicVolume: function(e) {
      if(!this.pip){
        return;
      }

      this.setSubVideoVAD(e.data);
    }
  }
}
</script>

<style lang="scss" scoped>
.p2p-video-main {
  position: relative;
}
.video-vip {
  .main-video {
    width: 100%;
    height: 100%;
    font-size: 0px;
  }
}

$sub-video-height: 100px;
.sub-videos {
  position: absolute;
  bottom: 2px;
  right: 2px;
  z-index: 2;
  width: 100%;
  height: $sub-video-height;
  text-align: right;
  pointer-events: none;
  background: transparent;
  overflow: hidden;
  //padding: 2px;

  &[data-pip-mode="true"] {
    bottom: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    padding: 0px;

    .sub-video {
      width: 100%;
      border: 0;
      cursor: default;
    }
  }

  &:not([data-pip-mode="true"]) {
    .sub-video {
      width: 180px;
    }
  }
  .sub-video {
    pointer-events: auto;
    position: relative !important;
    display: inline-block;
    max-width: 180px;
    height: inherit;
    border: 1px solid #747474;

    &:not(:first-child) {
      margin-left: 4px !important;
      border: 1px solid #747474;
    }

    video {
      width: auto;
      height: inherit;
    }
  }
}
.room-extend-menu-component{
  .sub-videos{
    .sub-video{
      max-width: unset;
    }
  }
}


</style>